export const adsBD = {
  name: 'Desktop_Jobs_VAP_3',
  width: 728,
  height: 90
};

export const adsRHS = [
  {
    name: 'Desktop_Jobs_VAP_2_1',
    width: 300,
    height: 250
  },
  {
    name: 'Desktop_Jobs_VAP_2_2',
    width: 300,
    height: 250,
    isSticky: true
  }
];

export const msiteAdsBD = {
  name: 'mSite_Jobs_VAP_2',
  width: 300,
  height: 250
};
